import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class RegGuard implements CanActivate {
  constructor(public auth: AuthenticationService) {}

  canActivate(): boolean {
    return this.auth.isRegistered();
  }
}
